export const headConfig = {
    '/': 'Home',
    '/login': 'Login',
    '/infomenu/register/applybet': 'ApplyBet',
};
